export const ROUTES = {
	ACCESS: '/access',
	AUTH: '/auth',
	HOME: '/',
	NEWS: '/news',
	BOOKS: '/books',
	PROGRAMS: '/programs',
	LESSONS: '/lessons',
	REPORT: '/report',
	CERTIFICATES: '/certificates',
	ACHIEVEMENT: '/achievements',
	ABOUT: '/about',
	STRENGTHS: '/strengths',
	GOALS: '/goals',
	STEPS: '/steps',
	CREATE: '/create',
	PORTFOLIO: '/portfolio',
	INDIVIDUALITY: '/individuality',
	INTERESTS: '/interests',
	QUALITIES: '/qualities',
	APPOINTMENTS: '/appointments',
	PROFILE: '/profile',
	GRADEBOOK: '/gradeBook',
	MONTH: '/month',
	CHAT: '/chat',
	HOMEWORK: '/homework',
	POLICIES: '/policies',
	MARKET: '/market',
	PAYMENT: '/payment',
	ONBOARDING: '/onboarding',
	TESTS: '/tests',
	DASHBOARD: '/dashboard',
	EDUCATION: '/education',
	FINANCIAL: '/financial',
	STUDENTS: '/students',
	B2B: '/b2b',
	RESULTS: '/results',
	RESET_PASSWORD: '/reset-password',
	EVENTS: '/events',
	CAREER_GUIDANCE: '/career-guidance',
	INFO: '/info',
	CLASSES_AND_STUDENTS: '/classes-and-students',
	BOOKINGS: '/bookings',
	BILLING: '/billing',
	PAYMENT_SUCCESS: '/billing/purchase-success',
} as const;

export type RouteKeys = keyof typeof ROUTES;

export function getRoute(keys: RouteKeys[], ...params: (string | number)[]): string {
	const basePath = keys.map((key) => ROUTES[key]).join('');
	return params?.length ? `${basePath}/${params.join('/')}` : basePath;
}

export type Routes = (typeof ROUTES)[keyof typeof ROUTES];
